module.exports = __webpack_public_path__ + "8b7cb306f97ad89e1336409ae6c7b08c.jpg";